var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee-container",on:{"mouseenter":_vm.pauseMarquee,"mouseleave":_vm.resumeMarquee}},[_c('div',{staticClass:"marquee2",class:{ paused: _vm.isPaused },style:({ transform: 'translateX(' + _vm.translateX + 'px)' }),attrs:{"id":"srollBox"},on:{"mousedown":_vm.startDrag,"mouseup":_vm.stopDrag}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }